import React from "react";
import { Calendar } from "primereact/calendar";
import { useTranslation } from "react-i18next";

const DateRangePicker = ({
  dates,
  setDates,
  placeholder = "Date",
  showButtonBar = true,
}) => {
  const { t } = useTranslation();

  const hasValue = Array.isArray(dates)
    ? dates?.some((d) => d)
    : !!dates;

  const handleChange = (e) => {
    setDates(e.value);
  };

  return (
    <div className={`date_range_picker ${hasValue ? "has-value" : ""}`}>
      <Calendar
        value={dates}
        onChange={handleChange}
        selectionMode="range"
        readOnlyInput
        hideOnRangeSelection
        showIcon
        placeholder={t(placeholder)}
        showButtonBar={showButtonBar}
        maxDate={new Date()}
      />
    </div>
  );
};

export default DateRangePicker;